import React, { useEffect, useRef } from 'react';
var SnippylyCommentsSidebar = function (props) {
    var embedMode = props.embedMode, enableUrlNavigation = props.enableUrlNavigation, urlNavigation = props.urlNavigation, openSidebar = props.openSidebar, onSidebarOpen = props.onSidebarOpen, onSidebarCommentClick = props.onSidebarCommentClick, onCommentClick = props.onCommentClick;
    var ref = useRef();
    useEffect(function () {
        if (ref.current) {
            var element = ref.current;
            element.addEventListener('onSidebarOpen', function (event) {
                if (openSidebar) {
                    openSidebar(event === null || event === void 0 ? void 0 : event.detail);
                }
                if (onSidebarOpen) {
                    onSidebarOpen(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
            element.addEventListener('onSidebarCommentClick', function (event) {
                if (onSidebarCommentClick) {
                    onSidebarCommentClick(event === null || event === void 0 ? void 0 : event.detail);
                }
                if (onCommentClick) {
                    onCommentClick(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
        }
    }, []);
    return (React.createElement("velt-comments-sidebar", { ref: ref, "embed-mode": [true, false].includes(embedMode) ? (embedMode ? 'true' : 'false') : undefined, "enable-url-navigation": [true, false].includes(enableUrlNavigation) ? (enableUrlNavigation ? 'true' : 'false') : undefined, "url-navigation": [true, false].includes(urlNavigation) ? (urlNavigation ? 'true' : 'false') : undefined }));
};
export default SnippylyCommentsSidebar;
